export default function Facility() {
  const facilityImages = [
    {
      id: 1,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/2f170ddb-36a6-4c7f-93f4-14672dd2f300_ninja-gym.jpg?v=137e98ed45f6b99719b7459badd1fdee',
      title: 'Ninja Gym',
      size: 'large'
    },
    {
      id: 2,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/88602a02-818f-4f70-9b0d-688c45e4defe_rock-wall---Copy.jpg?v=e449ed2ab39aa3c0f865549648a8bdb7',
      title: 'Rock Wall',
      size: 'small'
    },
    {
      id: 3,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/ded675c7-e167-4ed3-bbe0-9da44742cd3f_560347945_18291032782286126_4047214925934289723_n.jpg?v=bd034517a888a2b0f6924ba24021fe5d',
      title: 'Training Area',
      size: 'small'
    },
    {
      id: 4,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/9c988bc7-9c5d-410a-a2d5-abdd2b267728_569887380_18292994896286126_2904597450265578430_n.jpg?v=e3ec158d682d19e1920ebfa2f3cae4ae',
      title: 'Obstacles',
      size: 'medium'
    },
    {
      id: 5,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/a67c761f-281e-43f9-9883-457d91f7e619_581118420_1369909148478775_1770432032842281646_n.jpg?v=f2c8c471045f4b568314117172edffbf',
      title: 'Climbing',
      size: 'medium'
    },
    {
      id: 6,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/1e3e5799-1de7-488b-bf29-9e578fde9caf_581224099_1369913165145040_8019902229362258347_n.jpg?v=f4df35cd4d4cdfa02351d0809fe2fd7a',
      title: 'Equipment',
      size: 'small'
    },
    {
      id: 7,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/43110afa-e70b-4c9a-8b2c-9aa62ab1c3eb_615906735_18303523555286126_1898908881361485602_n.jpg?v=03d2ac4b60f4199c5d7f87f996296caa',
      title: 'Gym Floor',
      size: 'small'
    },
    {
      id: 8,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/9d55c3b0-df89-4395-956a-98662ba80a06_8-Warp-Wall.jpg?v=1e2546360466d8a87c85d002648f154a',
      title: 'Warp Wall',
      size: 'medium'
    },
    {
      id: 9,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/a658a71a-041e-4484-861c-b56200fbed73_9.jpeg?v=0ee885e0ac6e3daa69a7dc3cdfdb2441',
      title: 'Training',
      size: 'medium'
    },
    {
      id: 10,
      url: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/a41cbc0d-960f-4003-a335-64ac10fa698e_10-Rock-Wall.jpg?v=24a9023a5088cfc5ca622ce224f71428',
      title: 'Rock Wall',
      size: 'large'
    }
  ];

  return (
    <section id="facility" className="py-24 bg-gray-50 relative">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16 relative z-20">
          <div className="inline-block bg-[#0A1628]/90 backdrop-blur-sm px-8 py-4 rounded-full">
            <h2 className="text-4xl md:text-5xl font-black text-white">
              Our Facility
            </h2>
          </div>
        </div>

        {/* Masonry Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {facilityImages.map((image) => (
            <div
              key={image.id}
              className={`relative overflow-hidden group cursor-pointer ${
                image.size === 'large'
                  ? 'col-span-2 row-span-2 h-96'
                  : image.size === 'medium'
                  ? 'col-span-1 row-span-2 h-96'
                  : 'col-span-1 row-span-1 h-48'
              }`}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
              />

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-[#FF6B35]/0 group-hover:bg-[#FF6B35]/80 transition-all duration-400 flex items-center justify-center">
                <div className="text-white text-center opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                  <p className="text-xl font-bold mb-2">{image.title}</p>
                  <p className="text-sm">View Facility</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <button className="bg-white text-[#0A1628] px-12 py-5 rounded-full font-bold text-lg hover:bg-[#FF6B35] hover:text-white transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            Schedule a Tour
          </button>
        </div>
      </div>
    </section>
  );
}
